webpackJsonp([1],{

/***/ "+hHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('md-layout',{attrs:{"md-gutter":""}},[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex":"80","md-align":"center"}},[_c('router-view',{attrs:{"id":"content"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3lKx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Yqx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BLtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.treeCount)+" trees were cut down.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Each tree represents "+_vm._s(_vm.valuePerIcon)+" trees cut down.\n        ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://www.greenpeace.org/usa/forests/solutions-to-deforestation/"}},[_vm._v("\n            Learn about deforestation.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[(_vm.treeIconsCount < 1)?_c('span',[_c('md-icon',{attrs:{"md-iconset":"fa"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.treeIconsCount),function(tree){return _c('span',{key:tree},[_c('md-icon',{staticClass:"green-tree",attrs:{"md-iconset":"fa fa-tree"}})],1)}),_vm._v(" "),(_vm.treeIconsCount >= 1000)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(Math.floor((_vm.treeCount - 1000) / this.valuePerIcon))+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CpXo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GX1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['milliSecondsPassed'],
    computed: {
        deathsCount: function deathsCount() {
            return Math.floor(this.deaths);
        },
        starvationDeathsCount: function starvationDeathsCount() {
            return Math.floor(this.starvationDeaths);
        }
    },
    watch: {
        deaths: function deaths(newValue, old) {
            // only display up to 1000 items,
            if (newValue < 1000) {
                var newDeaths = Math.floor(newValue) - Math.floor(old);
                for (var i = 0; i < newDeaths; i++) {
                    var color = Math.random() < 0.16 ? 'red' : 'black';
                    this.deathsArray.push(color);
                }
            }
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.deaths = 0.1783 * _this.milliSecondsPassed;
            _this.starvationDeaths = 0.03 * _this.milliSecondsPassed;
        }, 100);
    },
    data: function data() {
        return {
            deaths: 0,
            starvationDeaths: 0,
            deathsArray: []
        };
    }
});

/***/ }),

/***/ "ISo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Oil_vue__ = __webpack_require__("Limh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e1c856_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Oil_vue__ = __webpack_require__("UFn4");
function injectStyle (ssrContext) {
  __webpack_require__("cm82")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e1c856"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Oil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e1c856_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Oil_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Im5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charity_vue__ = __webpack_require__("PgSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c21af1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Charity_vue__ = __webpack_require__("l25d");
function injectStyle (ssrContext) {
  __webpack_require__("apbg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c21af1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c21af1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Charity_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Limh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        oilCount: function oilCount() {
            return Math.floor(this.oil);
        },
        oilIconsCount: function oilIconsCount() {
            if (this.oil / this.valuePerIcon > 10) {
                return 10;
            }
            return Math.floor(this.oil / this.valuePerIcon);
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.oil += 916.6 / 10;
        }, 100);
    },
    data: function data() {
        return {
            oil: 0,
            valuePerIcon: 250
        };
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167e8842_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+hHf");
function injectStyle (ssrContext) {
  __webpack_require__("7Yqx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167e8842_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9oY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        waterBottleCount: function waterBottleCount() {
            return Math.floor(this.waterBottle);
        },
        waterBottleIconsCount: function waterBottleIconsCount() {
            if (this.waterBottle / this.valuePerIcon > 1000) {
                return 1000;
            }
            return Math.floor(this.waterBottle / this.valuePerIcon);
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.waterBottle += 1500 / 10;
        }, 100);
    },
    data: function data() {
        return {
            waterBottle: 0,
            valuePerIcon: 500
        };
    }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__("tzNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__("Q/Y2"));
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
    }
});

/***/ }),

/***/ "PgSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        charityCount: function charityCount() {
            return Math.floor(this.charity);
        },
        charityIconsCount: function charityIconsCount() {
            if (this.charity / this.valuePerIcon > 1000) {
                return 1000;
            }
            return Math.floor(this.charity / this.valuePerIcon);
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.charity += 52286.45 / 10;
        }, 100);
    },
    data: function data() {
        return {
            charity: 0,
            valuePerIcon: 10000
        };
    }
});

/***/ }),

/***/ "QxFN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RlrE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        treeCount: function treeCount() {
            return Math.floor(this.tree);
        },
        treeIconsCount: function treeIconsCount() {
            if (this.tree / this.valuePerIcon > 1000) {
                return 1000;
            }
            return Math.floor(this.tree / this.valuePerIcon);
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.tree += 34 / 10;
        }, 100);
    },
    data: function data() {
        return {
            tree: 0,
            valuePerIcon: 10
        };
    }
});

/***/ }),

/***/ "RxOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.deathsCount)+" deaths have occured.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.starvationDeathsCount)+" because of starvation.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Red represents a death due to starvation.\n        ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.riseagainsthunger.org/"}},[_vm._v("Help end world hunger.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[_vm._l((_vm.deathsArray),function(death){return _c('span',{key:death},[(death == 'red')?_c('md-icon',{staticClass:"red-person",attrs:{"md-iconset":"fa fa-user"}}):_c('md-icon',{attrs:{"md-iconset":"fa fa-user"}})],1)}),_vm._v(" "),(_vm.deaths > 1000)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(_vm.deathsCount - 1000)+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T5Kh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.waterBottleCount)+" plastic watter bottles have been consumed in the USA.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Each water glass represents "+_vm._s(_vm.valuePerIcon)+" plastic bottles.\n        ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://www.greeneducationfoundation.org/nationalgreenweeksub/waste-reduction-tips/tips-to-use-less-plastic.html"}},[_vm._v("\n            Learn to reduce use of plastic items.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[(_vm.waterBottleIconsCount < 1)?_c('span',[_c('md-icon',{attrs:{"md-iconset":"fa"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.waterBottleIconsCount),function(waterBottle){return _c('span',{key:waterBottle},[(waterBottle < 1000)?_c('md-icon',{staticClass:"blue-bottle"},[_vm._v("local_drink")]):_vm._e()],1)}),_vm._v(" "),(_vm.waterBottleIconsCount >= 1000)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(Math.floor((_vm.waterBottleCount - 1000) / this.valuePerIcon))+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UFn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.oilCount)+" barrels of oil were used.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Each droplet represents "+_vm._s(_vm.valuePerIcon)+" barrels of oil.\n        ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.nrel.gov/workingwithus/learning.html"}},[_vm._v("\n            Learn about renewable energy alternatives.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[(_vm.oilIconsCount < 1)?_c('span',[_c('md-icon',{attrs:{"md-iconset":"fa"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.oilIconsCount),function(oil){return _c('span',{key:oil},[_c('md-icon',{staticClass:"black-oil",attrs:{"md-iconset":"fa fa-tint"}})],1)}),_vm._v(" "),(_vm.oilIconsCount >= 10)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(Math.floor((_vm.oilCount - 1000) / this.valuePerIcon))+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uhku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_Deaths_vue__ = __webpack_require__("keJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_Births_vue__ = __webpack_require__("n0H8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_Garbage_vue__ = __webpack_require__("YEDp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_WaterBottleUse_vue__ = __webpack_require__("fxcv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_Trees_vue__ = __webpack_require__("shXh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_Oil_vue__ = __webpack_require__("ISo1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__events_Charity_vue__ = __webpack_require__("Im5u");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var moment = __webpack_require__("PJh5");
// require('hacktimer');
/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DeathsView: __WEBPACK_IMPORTED_MODULE_0__events_Deaths_vue__["a" /* default */], BirthsView: __WEBPACK_IMPORTED_MODULE_1__events_Births_vue__["a" /* default */], GarbageView: __WEBPACK_IMPORTED_MODULE_2__events_Garbage_vue__["a" /* default */], WaterBottleUseView: __WEBPACK_IMPORTED_MODULE_3__events_WaterBottleUse_vue__["a" /* default */], TreeView: __WEBPACK_IMPORTED_MODULE_4__events_Trees_vue__["a" /* default */], OilView: __WEBPACK_IMPORTED_MODULE_5__events_Oil_vue__["a" /* default */], CharityView: __WEBPACK_IMPORTED_MODULE_6__events_Charity_vue__["a" /* default */]
    },
    computed: {
        formatedSeonds: function formatedSeonds() {
            return moment.utc(this.now * 1000).format('HH:mm:ss');
        },
        birthsCount: function birthsCount() {
            return Math.floor(this.births);
        }
    },
    created: function created() {
        var _this = this;

        this.startedAt = moment();
        window.setInterval(function () {
            var timePassed = moment() - _this.startedAt;
            var secondsPassed = Math.floor(timePassed / 1000);
            _this.now = secondsPassed;
            _this.milliSecondsPassed = timePassed / 100;
        }, 100);
    },
    data: function data() {
        return {
            startedAt: 0,
            now: 0,
            milliSecondsPassed: 0
        };
    }
});

/***/ }),

/***/ "YEDp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Garbage_vue__ = __webpack_require__("g9Ms");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db04339_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Garbage_vue__ = __webpack_require__("rZdE");
function injectStyle (ssrContext) {
  __webpack_require__("QxFN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4db04339"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Garbage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db04339_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Garbage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__("s6+2");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'In a second',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */]
    }]
}));

/***/ }),

/***/ "apbg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cm82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fxcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaterBottleUse_vue__ = __webpack_require__("M9oY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b92894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WaterBottleUse_vue__ = __webpack_require__("T5Kh");
function injectStyle (ssrContext) {
  __webpack_require__("CpXo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48b92894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaterBottleUse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b92894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WaterBottleUse_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g9Ms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        tonsTrashCount: function tonsTrashCount() {
            return Math.floor(this.tonsTrash);
        },
        tonsTrashIconsCount: function tonsTrashIconsCount() {
            if (this.tonsTrash / this.valuePerIcon > 1000) {
                return 1000;
            }
            return Math.floor(this.tonsTrash / this.valuePerIcon);
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.tonsTrash += 41.667 / 10;
        }, 100);
    },
    data: function data() {
        return {
            tonsTrash: 0,
            valuePerIcon: 10
        };
    }
});

/***/ }),

/***/ "kPQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.birthsCount)+" children have been born.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-title md-warn"},[_c('span',{staticClass:"orange"},[_vm._v(" "+_vm._s(_vm.povertyBirthsCount)+" ")]),_vm._v(" were born into poverty.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Orange represents a child born into poverty.\n        ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://endpoverty.org/"}},[_vm._v("Help end poverty.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[_vm._l((_vm.birthsArray),function(birth){return _c('span',{key:birth},[(birth == 'red')?_c('md-icon',{staticClass:"orange-person",attrs:{"md-iconset":"fa fa-user"}}):_c('md-icon',{attrs:{"md-iconset":"fa fa-user"}})],1)}),_vm._v(" "),(_vm.births > 1000)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(_vm.birthsCount - 1000)+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "keJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deaths_vue__ = __webpack_require__("GX1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f281aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Deaths_vue__ = __webpack_require__("RxOq");
function injectStyle (ssrContext) {
  __webpack_require__("3lKx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0f281aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deaths_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f281aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Deaths_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l25d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            $"+_vm._s(_vm.charityCount)+" dollars has been donated to charity.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Each $ represents $"+_vm._s(_vm.valuePerIcon)+".\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            You can help make a difference.\n        ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.charitywatch.org/toprated"}},[_vm._v("Find worthy charities.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[(_vm.charityIconsCount < 1)?_c('span',[_c('md-icon',{attrs:{"md-iconset":"fa"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.charityIconsCount),function(charity){return _c('span',{key:charity},[_c('md-icon',{staticClass:"green-money",attrs:{"md-iconset":"fa fa-usd"}})],1)}),_vm._v(" "),(_vm.charityIconsCount >= 1000)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(Math.floor((_vm.charityCount - 1000) / this.valuePerIcon))+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lvQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n0H8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Births_vue__ = __webpack_require__("v2Q5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340cd880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Births_vue__ = __webpack_require__("kPQy");
function injectStyle (ssrContext) {
  __webpack_require__("lvQA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-340cd880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Births_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340cd880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Births_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p53m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rZdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-column":"","md-flex":""}},[_c('md-layout',{attrs:{"md-column":"","md-align":"center"}},[_c('span',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.tonsTrashCount)+" tons of garbage have been dumped.\n        ")]),_vm._v(" "),_c('span',{staticClass:"md-subheading"},[_vm._v("\n            Each trashcan represents "+_vm._s(_vm.valuePerIcon)+" tons.\n        ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.epa.gov/recycle/reducing-waste-what-you-can-do/"}},[_vm._v("\n            Learn to reduce waste.")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"start"}},[(_vm.tonsTrashIconsCount < 1)?_c('span',[_c('md-icon',{attrs:{"md-iconset":"fa"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.tonsTrashIconsCount),function(ton){return _c('span',{key:ton},[(ton < 1000)?_c('md-icon',{attrs:{"md-iconset":"fa fa-trash"}}):_vm._e()],1)}),_vm._v(" "),(_vm.tonsTrashIconsCount >= 1000)?_c('span',{staticClass:"md-title"},[_vm._v("\n            + "+_vm._s(Math.floor((_vm.tonsTrashCount - 1000) / this.valuePerIcon))+" more\n        ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s6+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("Uhku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41235573_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("sbnK");
function injectStyle (ssrContext) {
  __webpack_require__("p53m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41235573_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sbnK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-icon',{staticClass:"md-size-3x md-accent",attrs:{"md-iconset":"fa fa-heart"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-column":""}},[_c('md-layout',{attrs:{"md-align":"center"}},[_c('span',{staticClass:"md-display-1"},[_vm._v("Time since entering site:")])]),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"center"}},[_c('span',{staticClass:"md-display-3"},[_vm._v(_vm._s(_vm.formatedSeonds))])]),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"center"}},[_c('span',{staticClass:"md-display-1"},[_vm._v("While you've been here")])])],1),_vm._v(" "),_c('hr',{attrs:{"id":"seperator"}}),_vm._v(" "),_c('deaths-view',{attrs:{"milliSecondsPassed":_vm.milliSecondsPassed}}),_vm._v(" "),_c('hr',{staticClass:"statistic-seperator"}),_vm._v(" "),_c('births-view',{attrs:{"milliSecondsPassed":_vm.milliSecondsPassed}}),_vm._v(" "),_c('hr',{staticClass:"statistic-seperator"}),_vm._v(" "),_c('garbage-view'),_vm._v(" "),_c('hr',{staticClass:"statistic-seperator"}),_vm._v(" "),_c('water-bottle-use-view'),_vm._v(" "),_c('hr',{staticClass:"statistic-seperator"}),_vm._v(" "),_c('tree-view'),_vm._v(" "),_c('hr',{staticClass:"statistic-seperator"}),_vm._v(" "),_c('oil-view'),_vm._v(" "),_c('hr',{staticClass:"statistic-seperator"}),_vm._v(" "),_c('charity-view'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr',{attrs:{"id":"seperator"}}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"md-subheading"},[_c('em',[_vm._v("\"For every minute you remain angry, you give up sixty seconds of peace of mind.\"")]),_vm._v(" \n        — Ralph Waldo Emerson\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "shXh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trees_vue__ = __webpack_require__("RlrE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a167699_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Trees_vue__ = __webpack_require__("BLtE");
function injectStyle (ssrContext) {
  __webpack_require__("wi1S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a167699"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trees_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a167699_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Trees_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2Q5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['milliSecondsPassed'],
    computed: {
        birthsCount: function birthsCount() {
            return Math.floor(this.births);
        },
        povertyBirthsCount: function povertyBirthsCount() {
            return Math.floor(this.povertyBirths);
        }
    },
    watch: {
        births: function births(newValue, old) {
            // only display up to 1000 items,
            if (newValue < 1000) {
                var newBirths = Math.floor(newValue) - Math.floor(old);
                for (var i = 0; i < newBirths; i++) {
                    var color = Math.random() < 0.52 ? 'red' : 'black';
                    this.birthsArray.push(color);
                }
            }
        }
    },
    created: function created() {
        var _this = this;

        window.setInterval(function () {
            _this.births = 0.416 * _this.milliSecondsPassed;
            _this.povertyBirths = 0.188 * _this.milliSecondsPassed;
        }, 100);
    },
    data: function data() {
        return {
            births: 0,
            povertyBirths: 0,
            birthsArray: []
        };
    }
});

/***/ }),

/***/ "wi1S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a5821c6d5d49ba2813ca.js